import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css'
})
export class Sidebar {
  private router = inject(Router);
  collapsed = signal(false);

  toggle() {
    this.collapsed.set(!this.collapsed());
  }

  isActive(route: string): boolean {
    return this.router.url === route || this.router.url.startsWith(route);
  }
}
